import React from 'react';
import Title from './Title';
import AppTabs from '../../core/Tabs/AppTabs';
import Tab from '@material-ui/core/Tab';
import { makeStyles } from '@material-ui/core/styles';
import AppTabPanel from '../../core/Tabs/AppTabPanel';
import KantoAccess from './KantoAccess';
import KansaiAccess from './KansaiAccess';

const SPACE = 8;

const useStyles = makeStyles((theme) => ({
  indicator: {
    display: 'none',
  },
  tabRoot: {
    maxWidth: 'none',
    width: '50%',
    fontWeight: 'bold',
    borderRadius: '10px 10px 0 0',
    fontSize: theme.typography.pxToRem(18),
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.common.white,
    opacity: 1,
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(22),
      padding: theme.spacing(2),
    },
  },
  selected: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.dark,
  },
  flexContainer: {
    width: `calc(100% - ${SPACE}px)`,
    margin: 'auto',
  },
}));

const KANTO = 0;
const KANSAI = 1;

const Access = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(KANTO);
  return (
    <div>
      <Title text="ACCESS">飛騨市へのアクセス</Title>
      <div>
        <AppTabs
          value={value}
          onChange={(event, newValue) => setValue(newValue)}
          classes={{
            flexContainer: classes.flexContainer,
            indicator: classes.indicator,
          }}
          variant="standard"
          centered
          AppBarProps={{ color: 'transparent' }}
        >
          <Tab
            label="東京から"
            id="access-tab-kanto"
            aria-controls="access-tabpanel-kanto"
            style={{ marginRight: SPACE / 2 }}
            value={KANTO}
            classes={{ root: classes.tabRoot, selected: classes.selected }}
          />
          <Tab
            label="大阪から"
            id="access-tab-kansai"
            aria-controls="access-tabpanel-kansai"
            style={{ marginLeft: SPACE / 2 }}
            value={KANSAI}
            classes={{ root: classes.tabRoot, selected: classes.selected }}
          />
        </AppTabs>
        <AppTabPanel
          aria-labelledby="access-tab-kanto"
          id="access-tabpanel-kanto"
          hidden={value !== KANTO}
        >
          <KantoAccess />
        </AppTabPanel>
        <AppTabPanel
          aria-labelledby="access-tab-kansai"
          id="access-tabpanel-kansai"
          hidden={value !== KANSAI}
        >
          <KansaiAccess />
        </AppTabPanel>
      </div>
    </div>
  );
};

export default Access;
